import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClosePassword = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 12,
	viewBox: "0 0 22 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.8651 1C19.5892 3.20492 18.5607 5.22917 16.9711 6.69561C15.3816 8.16206 13.3394 8.97068 11.225 8.97083C9.11067 8.97098 7.06837 8.16264 5.47862 6.69642C3.88887 5.2302 2.8601 3.20609 2.58398 1.00122",
			stroke: "#D1D9E2",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2598 8.5L16.8443 11",
			stroke: "#D1D9E2",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4297 5.1665L20.9988 6.48023",
			stroke: "#D1D9E2",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4297 5.1665L20.9988 6.48023",
			stroke: "#D1D9E2",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.56836 5.1665L0.999272 6.48023",
			stroke: "#D1D9E2",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.54492 11L8.12948 8.49998",
			stroke: "#D1D9E2",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgClosePassword;
